import { createRouter, createWebHistory } from 'vue-router';
import APE from '../views/AnnualPerformanceEvaluation.vue';
import Error from '../views/Error.vue';
import Success from '../views/Success.vue';
import EventContributionForm from '../views/EventContributionForm.vue';

const routes = [
  { path: '/APE', name: 'Annual Performance Evaluation', component: APE },
  { path: '/event', name: 'Event Contribution Form', component: EventContributionForm },

  { path: '/error', name: 'Error', component: Error },
  { path: '/success', name: 'Success', component: Success },
  { path: '/:pathMatch(.*)*', name: 'Error', component: Error },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
